// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopoverInput-Popover .CloseButton {
  display: none;
}
.PopoverInput-Popover .popover-body {
  box-sizing: content-box;
  overflow: hidden;
  padding: 0;
  border-radius: var(--bs-popover-border-radius);
}`, "",{"version":3,"sources":["webpack://./src/common/PopoverInput/styles.scss"],"names":[],"mappings":"AAIE;EACE,aAAA;AAHJ;AAKE;EACE,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,8CAAA;AAHJ","sourcesContent":[".PopoverInput.Common {\n}\n\n.PopoverInput-Popover {\n  .CloseButton {\n    display: none;\n  }\n  .popover-body {\n    box-sizing: content-box;\n    overflow: hidden;\n    padding: 0;\n    border-radius: var(--bs-popover-border-radius);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
